module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('v-sidebar', {
    attrs: {
      "activeNavItem": "shipment"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "main-panel"
  }, [_c('v-navbar', {
    attrs: {
      "title": 'Shipment Tracking',
      "path": "/shipment"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h4', [_vm._v("Tracking details")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Id: " + _vm._s(_vm.id))]), _c('br'), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Shipper address: " + _vm._s(_vm.shipperAddress))]), _c('br'), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Consignee address: " + _vm._s(_vm.consigneeAddress))]), _c('br'), _vm._v(" "), (_vm.showMap) ? _c('LeafletMap', {
    attrs: {
      "height": "500px",
      "starting-center": [_vm.mapCenter.lat, _vm.mapCenter.lng],
      "points": _vm.trackingPoints,
      "lines": _vm.lines,
      "fitToMarkers": ""
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/shipment/view"
    }
  }, [_vm._v("Back to Shipments")])], 1)])])]), _vm._v(" "), _c('v-footer')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "legend-gps"
  }), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("GPS Points")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "legend-estimate"
  }), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Estimate Route")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ccac5a96"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/shipment/ShipmentTracking.vue
// module id = 773
// module chunks = 0